import { render, staticRenderFns } from "./AuthInstructions.vue?vue&type=template&id=4f12cd44&scoped=true&"
import script from "./AuthInstructions.vue?vue&type=script&lang=js&"
export * from "./AuthInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AuthInstructions.vue?vue&type=style&index=0&id=4f12cd44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12cd44",
  null
  
)

export default component.exports